export default {
  create_org: {
    title: 'Manage your Own Academic Events',
    description:
      'Create stunning event websites and simplify the management of abstracts, reviews, and registrations easily. Save time and deliver a memorable experience for your participants.',
    modal_title: 'Create Organization',
    maybe_later: 'Maybe Later',
    create: 'Get Started',
    infos: {
      title: 'General Info',
      name: 'Organization Name',
      name_hint: 'Be as specific as possible. This could be your department, lab, or the name of your conference.',
      address: 'Street Address',
      address_hint: 'Required to publish your events, upgrade your plan, etc.',
      city: 'City',
      zip: 'Postal / Zip Code',
    },
    add_admins: {
      title: 'Add Organization Admins',
      subtitle:
        'Invite your colleagues to join your organization. An email will be sent to each admin with a link to activate their account or login.',
      emails: 'Email Addresses',
      emails_placeholder: 'colleague@something.edu',
      emails_help: 'Type one or more email addresses.',
    },
    success_message: 'Organization successfully created!',
  },
};
